export const LANDING = {
  takeTest: 'landing-take-test-button',
  pricing: 'landing-pricing-button',
  admin: 'landing-admin-link',
  navHome: 'nav-home-link',
  navPricing: 'nav-pricing-link',
  navTakeTest: 'nav-take-test-link',
};

export const PRICING = {
  planCard: 'pricing-plan-card',
  buyButton: 'pricing-buy-button',
};

export const CHECKOUT = {
  planSelect: 'checkout-plan-select',
  name: 'checkout-name-input',
  email: 'checkout-email-input',
  phone: 'checkout-phone-input',
  quantity: 'checkout-quantity-input',
  payButton: 'checkout-pay-button',
  success: 'checkout-success',
  testIdItem: 'checkout-testid-item',
  error: 'checkout-error',
};

export const INSTITUTION = {
  codeInput: 'institution-code-input',
  lookupButton: 'institution-lookup-button',
  summary: 'institution-summary',
  error: 'institution-error',
};
